export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "7caebe8b-7528-4ed8-8187-26f30a3d1442";
export const CLOSE_SEC = "1000";
